import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  "aria-label": "...",
  class: "d-flex justify-content-end"
}
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { class: "page-link" }, "Prev", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "page-link",
  href: "#"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "page-link",
  href: "#"
}, "Next ", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPreviousPage && _ctx.onClickPreviousPage(...args))),
        class: _normalizeClass(["page-item", { disabled: _ctx.isInFirstPage }])
      }, _hoisted_4, 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
        return (_openBlock(), _createElementBlock("li", {
          onClick: ($event: any) => (_ctx.onClickPage(page.name)),
          class: _normalizeClass(["page-item", { active: page.isDisabled }]),
          key: page.name
        }, [
          _createElementVNode("a", _hoisted_6, _toDisplayString(page.name), 1)
        ], 10, _hoisted_5))
      }), 128)),
      _createElementVNode("li", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickNextPage && _ctx.onClickNextPage(...args))),
        class: _normalizeClass(["page-item", { disabled: _ctx.isInLastPage }])
      }, _hoisted_8, 2)
    ])
  ]))
}